import { useEffect } from 'react';

import { useAtom } from 'jotai';

import type { RegionsAreasAggsType } from '@core/Entities/Location/RegionArea.entity';

import { locationAggregationsAtom } from '../Atoms/LocationAggregationAtom/LocationAggregationAtom';
import { aggregationsToRegionsAreas } from '../Utils/AggregationToRegionAndAreas';

const useLocationAggregations = (locationAttrs: {
  areas: RegionsAreasAggsType;
  regions: RegionsAreasAggsType;
}) => {
  const [state, setRegionAreas] = useAtom(locationAggregationsAtom);
  const hasInitialState = state.regions?.length > 0;

  const fetchRegionArea = async () => {
    const { regions, areas } = aggregationsToRegionsAreas(
      locationAttrs.areas,
      locationAttrs.regions,
    );
    setRegionAreas({
      ...state,
      isLoading: false,
      regions: regions,
      areas: areas,
    });
  };

  useEffect(() => {
    if (hasInitialState) return;
    fetchRegionArea();
  }, [hasInitialState]);
};

export { useLocationAggregations };
